// config.ts
type Env = 'local' | 'dev' | 'prod';
type EnvConfig = {
    serverUrl: string;
    wsServerUrl: string;
    cdnUrl: string;
    env: Env;
    LOADING_TIMEOUT_MS:number;
};

interface AppConfig extends EnvConfig {
    VERSION: string;
    isNutaku: boolean;
    isAndroid: boolean;
    isWindows:boolean;
    LOADING_TIMEOUT_MS: number;
    LOADING_TIMEOUT_MS_ANDROID: number;
    MAX_SEASON_LEVEL: number;
    BOT_TIMER_START: number;
    BOT_TIMER_END: number;
    MANA_CARDS:any;
}

const configs: Record<Env, EnvConfig> = {
    local: {
        serverUrl: "http://localhost:8081",
        wsServerUrl: "ws://0.0.0.0:2347",
        cdnUrl: "http://localhost:3000",
        env: 'local',
        LOADING_TIMEOUT_MS: 1000
    },
    dev: {
        serverUrl: "https://devapi.depraved.world",
        wsServerUrl: "wss://devapi.depraved.world/wss",
        cdnUrl: "https://dev.nutaku.depraved.world",
        env: 'dev',
        LOADING_TIMEOUT_MS: 5000
    },
    prod: {
        serverUrl: "https://nutakuapi.depraved.world",
        wsServerUrl: "wss://nutakuapi.depraved.world/wss",
        cdnUrl: "https://nutaku.depraved.world",
        env: 'prod',
        LOADING_TIMEOUT_MS: 20000
    },
};

const ENV: Env = 'dev';

export const config: AppConfig = {

    VERSION: '1.6-na8',
    ...configs[ENV],

    isNutaku: true,
    isAndroid: false,
    isWindows: false,

    LOADING_TIMEOUT_MS_ANDROID: 5000,
    MAX_SEASON_LEVEL: 101,
    BOT_TIMER_START: 20,
    BOT_TIMER_END: 30,
    MANA_CARDS : new Set([
        1042, 1043, 1044,
        1080, 1081, 1082,
        1118, 1119, 1120,
        1140
    ]),
};
